import React, { Component } from "react";
import View from "./view";
import "./index.css";
import {getUser} from "../../../backend/storage";

import { getStoreComments, getStore, notiAction } from "../../../backend/stores";
import { withRouter } from "react-router-dom";
import { updateRoute } from "../../../redux/actions";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell} from "@fortawesome/free-solid-svg-icons";
class CommentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [],
      storeLocation: "",
      loading: false,
      storeSelect: null,
      notis : [],
      notis_permanent : [],
      showNotiActionedOverlay:false,
      selectedNoti: '',
      notiActioned : null,
    };
    this._change = this._change.bind(this);
    this._navigate = this._navigate.bind(this);
    this._selectStore = this._selectStore.bind(this);
    this._renderNoti = this._renderNoti.bind(this);
    this._showNotiActionedOverlay = this._showNotiActionedOverlay.bind(this);
    this._closeNotiActionedOverlay = this._closeNotiActionedOverlay.bind(this);
  }

  async componentDidMount() {
    if (this.props.match.params.store_id) {
      this.setState({ loading: true });
      let store = await getStore(this.props.match.params.store_id);
      this.setState({
        comments: await getStoreComments(this.props.match.params.store_id),
        loading: false,
        storeSelect: { label: store.name, value: store.id, use_app : store.use_app},
        notis : store.notis,
        notis_permanent:store.notis_permanent,
        user : await getUser(),
      });
      
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.store_id !== this.props.match.params.store_id) {
      this.setState({ loading: true });
      // let { name = null, id = null, use_app = null }
      let store = (await getStore(
        this.props.match.params.store_id
      )) || { name: null, id: null, use_app: null };

      this.setState({
        storeSelect: { label: store.name, value: store.id, use_app : store.use_app},
        comments: await getStoreComments(this.props.match.params.store_id),
        loading: false,
        notis: store.notis,
        notis_permanent : store.notis_permanent,
        user : await getUser(),
      });
    }
  }

  render() {
    return View.call(this);
  }

  _change(prop) {
    return event => this.setState({ [prop]: event.target.value });
  }

  _selectStore({ value, label, use_app }) {
    this.setState({ storeSelect: { value, label, use_app }});
    this._navigate(`/stores/${value}`)();
    this.props.updateRoute(value);
  }

  _renderStoreComment(
    { id, created_at, inspection_note, priority, store_id, alert },
    key
  ) {
    return (
      <div
        key={key}
        className={`comment ${priority} alert_${alert}`}
        onClick={this._navigate(`/comment-form/${store_id}/${id}`)}
      >
        <div className="note">{inspection_note}</div>
        <div className="status">{priority}</div>
        <div className="last-inspection">{created_at}</div>
      </div>
    );
  }

  _renderNoti(
    { id, actionable, message, index },key) {
    return (
      // action이 필요한 아이템은 클릭시 이벤트 발생 
      // type_id == 3 (Merchandiser 만 이벤트 발생시키기 가능)
      <div key={key} className={`noti id-${id} `}>
        <div className="message"><FontAwesomeIcon icon={faBell} size="1x" /> {message}
        { (this.state.user.type_id === 3 && actionable === 1) && (<button className="noti_close" onClick={()=>{this._showNotiActionedOverlay({ id, actionable, message, key }) }}>X</button>)}
        </div>
      </div>
    );
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }
  _showNotiActionedOverlay(noti){
    this.setState({showNotiActionedOverlay : true, selectedNoti : noti})
    
  }
  async _notiActioned(noti){
    // 데이터 전송하기 
    let notiActioned = await notiAction(noti.id)
    if( notiActioned === 200 ){ // success : list 에서 빼기 
      let newNotiList = this.state.notis.splice(noti.key, 1);
      this.setState({noti: newNotiList})
      this._closeNotiActionedOverlay()
    }
  }
  _closeNotiActionedOverlay(){
    this.setState({showNotiActionedOverlay : false, selectedNoti: null})
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateRoute: store_id => {
      dispatch(updateRoute("stores", `/stores/${store_id}`));
      dispatch(updateRoute("machines", `/machines/${store_id}`));
      dispatch(updateRoute("create", `/comment-form/${store_id}`));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CommentList)
);



// WEBPACK FOOTER //
// ./src/screens/stores/comment-list/index.js